import React, { useEffect, useState } from 'react';
import { Outlet, useParams, useLocation } from 'react-router-dom';
import { checkUser } from 'src/actions/userActions';
import { Spin } from 'antd';
import { checkIfObjectEmpty } from 'src/utils/helper';
import { connect } from 'react-redux';
import store from 'src/redux/store/reduxStoreIndex';
import { getActiveModelRedux } from 'src/redux/actions/activeModelActions';

import { getSettingsRedux } from 'src/redux/actions/settingsActions';

const PublicRoute = (props) => {
	// this component checks the authentication status of the user
	const { activeUser, modelList, activeModel, settings } = props;
	const params = useParams();
	const location = useLocation();
	const [checkedAuth, setCheckedAuth] = useState(false);
	const { model } = activeModel;

	// this component checks the authentication status of a user and only renders the requested route if the user is authenticated,
	// otherwise it redirects to login page

	useEffect(() => {
		if (activeModel.isFetching) return;

		if ((!model?._id || model._id === '') && params.modelId) {
			store.dispatch(getActiveModelRedux(params.modelId));
		} else if ((!model?._id || model._id === '') && params.modelSlug) {
			store.dispatch(getActiveModelRedux(params.modelSlug, true));
		} else if (
			(!model?._id || model._id === '') &&
			activeUser.user.modelAccess &&
			activeUser.user.modelAccess.length !== 0 &&
			modelList.items.length > 1
		) {
			const firstModelId = modelList.items.find((item) => item.slug === activeUser.user.modelAccess[0])?._id;
			store.dispatch(getActiveModelRedux(firstModelId));
		}
	}, [modelList.items, activeUser.user, activeModel.isFetching, model._id, params.modelId, params.modelSlug]);

	useEffect(() => {
		let shouldUpdate = true;
		if (checkIfObjectEmpty(activeUser.user) && !activeUser.isFetching && !checkedAuth) {
			checkUser().then(() => {
				if (shouldUpdate) setCheckedAuth(true);
			});
		} else {
			setCheckedAuth(true);
		}

		return () => {
			shouldUpdate = false;
		};
	}, [activeUser, checkedAuth]);

	useEffect(() => {
		if (!settings.isFetching.menuColor && settings.menuColor.init) {
			store.dispatch(getSettingsRedux('menuColor'));
		}
		if (!settings.isFetching.windows && settings.windows.init) {
			store.dispatch(getSettingsRedux('windows'));
		}
	}, [settings]);

	if (checkedAuth || !activeUser.isFetching || location.pathname === '/login') {
		return <Outlet />;
	} else {
		return (
			<div style={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
				<Spin spinning />
			</div>
		);
	}
};

const mapStateToProps = (state) => ({
	activeUser: state.activeUser,
	activeModel: state.activeModel,
	modelList: state.modelList,
	settings: state.settings,
});

export default connect(mapStateToProps)(PublicRoute);
